/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InboundDocumentFolder = {
    NeedsTriage: 'NEEDS_TRIAGE',
    Orders: 'ORDERS',
    Auth: 'AUTH',
    Prescription: 'PRESCRIPTION',
    Junk: 'JUNK',
    Other: 'OTHER',
} as const;
export type InboundDocumentFolder = typeof InboundDocumentFolder[keyof typeof InboundDocumentFolder];


export function instanceOfInboundDocumentFolder(value: any): boolean {
    for (const key in InboundDocumentFolder) {
        if (Object.prototype.hasOwnProperty.call(InboundDocumentFolder, key)) {
            if (InboundDocumentFolder[key as keyof typeof InboundDocumentFolder] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InboundDocumentFolderFromJSON(json: any): InboundDocumentFolder {
    return InboundDocumentFolderFromJSONTyped(json, false);
}

export function InboundDocumentFolderFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentFolder {
    return json as InboundDocumentFolder;
}

export function InboundDocumentFolderToJSON(value?: InboundDocumentFolder | null): any {
    return value as any;
}

export function InboundDocumentFolderToJSONTyped(value: any, ignoreDiscriminator: boolean): InboundDocumentFolder {
    return value as InboundDocumentFolder;
}

